import React, { ReactElement } from 'react';
import Immutable from 'immutable';
import { useHits } from 'react-instantsearch';

import { Node } from '@uncinc/react-drupal-core';
import {
  SearchRecord,
  SearchEntity,
} from '../../../types/uncinc_profile/search';

import {
  CONTENT_TYPE_ARTICLE,
  CONTENT_TYPE_PROJECT,
} from '../../../config/constants';

import './style.scss';

interface Results {
  emptyState?: React.ReactElement,
  type: string,
  headerElement: ReactElement,
}

const MoreLikeThisResults: React.FC<Results> = (props) => {
  const {
    emptyState = <></>,
    type,
    headerElement,
  } = props;

  const { hits } = useHits();

  // Convert all hits to our search entity type.
  const typedHits = hits.map((hit) => hit as unknown as SearchRecord);
  // Sort hits of type article based on creation time.
  const sortedHits = typedHits[0]?.type[0] === CONTENT_TYPE_ARTICLE
    ? typedHits.sort((a, b) => b.created[0] - a.created[0])
    : typedHits;

  const searchEntities = Immutable.List(sortedHits.map((hit) => {
    // Translate the search data to Entity data for rendering.
    const result: SearchEntity = {
      title: [{ value: hit.page_title[0] }],
      langcode: [{ value: hit.langcode[0] }],
      created: [{ value: hit.created[0] * 1000 }],
      body: [{
        value: hit.body ? hit.body[0] : null,
        summary: hit.body_summarized ? hit.body_summarized[0] : null,
      }],
      type: [{ target_id: hit.type[0] }],
      paths: {
        nl: hit.url[0],
        en: hit.url[0],
      },
    };
    // Specific fields for Content type Article.
    if (hit.type[0] === CONTENT_TYPE_ARTICLE) {
      // TODO - https://uncinc.monday.com/boards/456111162/pulses/6565734732.
      return Immutable.fromJS({
        ...result,
        field_media_item: [{
          bundle: 'image',
          entity: {},
          styles: {
            ratio_3_4_xs: hit.ratio_3_4_xs ? hit.ratio_3_4_xs[0] : null,
            ratio_3_4_sm: hit.ratio_3_4_sm ? hit.ratio_3_4_sm[0] : null,
            ratio_3_4_md: hit.ratio_3_4_md ? hit.ratio_3_4_md[0] : null,
            ratio_3_4_lg: hit.ratio_3_4_lg ? hit.ratio_3_4_lg[0] : null,
            ratio_2_3_lg: hit.ratio_2_3_lg ? hit.ratio_2_3_lg[0] : null,
            ratio_1_1_xs: hit.ratio_1_1_xs ? hit.ratio_1_1_xs[0] : null,
            ratio_1_1_sm: hit.ratio_1_1_sm ? hit.ratio_1_1_sm[0] : null,
          },
        }],
        field_article_type: [{
          entity: { name: [{ value: hit.article_type_name ? hit.article_type_name[0] : null }] },
        }],
      });
    }
    // Specific fields for Content type Project.
    if (hit.type[0] === CONTENT_TYPE_PROJECT) {
      // TODO - https://uncinc.monday.com/boards/456111162/pulses/6565734732.
      return Immutable.fromJS({
        ...result,
        field_color_primary: [{ value: hit.color_primary ? hit.color_primary[0] : null }],
        field_color_secondary: [{ value: hit.color_secondary ? hit.color_secondary[0] : null }],
        field_teaser_image: [{
          bundle: 'image',
          entity: {},
          styles: {
            ratio_2_3_xs: hit.project_ratio_2_3_xs ? hit.project_ratio_2_3_xs[0] : null,
            ratio_2_3_sm: hit.project_ratio_2_3_sm ? hit.project_ratio_2_3_sm[0] : null,
            ratio_2_3_md: hit.project_ratio_2_3_md ? hit.project_ratio_2_3_md[0] : null,
            ratio_2_3_lg: hit.project_ratio_2_3_lg ? hit.project_ratio_2_3_lg[0] : null,
          },
        }],
        field_partner: [{
          entity: {
            title: [{ value: hit.partner_title ? hit.partner_title[0] : null }],
            field_media_item: [{
              source: hit.partner_svg_source_color ? hit.partner_svg_source_color[0] : null,
            }],
            field_media_item_secondary: [{
              source: hit.partner_svg_source_white ? hit.partner_svg_source_white[0] : null,
            }],
          },
        }],
      });
    }
    return result;
  }));

  return hits.length > 0 ? (
    <div className="MoreLikeThisResults">
      {/* Header render */}
      {headerElement}

      {/* Results */}
      <div className="MoreLikeThisResults__results row">
        {searchEntities.map((searchEntity) => (
          <Node
            entity={searchEntity}
            viewMode="teaser"
            classes={type === CONTENT_TYPE_PROJECT ? 'col-12 col-md-6 col-lg-4' : ''}
          />
        ))}
      </div>
    </div>
  ) : (
    <div> </div>
  );
};

export default MoreLikeThisResults;
